import {produce} from "immer"

import {
    LOAD_RECORDS_PROJECT_CACHE,
    LOAD_PROJECT_SUCCESS,
    LOAD_PROJECT_ERROR,
    LOAD_PHASE_SUCCESS,
    LOAD_PHASE_ERROR,
    LOAD_DROPDOWN_PROJECT_SUCCESS,
    LOAD_DROPDOWN_PROJECT_ERROR,
} from "./constant"

const initialState = {
        projectlist:[],
        phaselist:[],
        success:false,
        error:false,
        dropdownlist:[],
        totalRecords:0,
        loading:false,
        lastupdate:null,
}

const Reducer = (state=initialState,{type,projectlist,phaselist,error,dropdownlist})=>{
    return produce(state, (draft)=>{
        switch(type){
            case LOAD_RECORDS_PROJECT_CACHE:
                draft.loading = false;
                draft.success = false;
                draft.error = false;
                break;

            case LOAD_PROJECT_SUCCESS:
                draft.projectlist = projectlist;
                draft.success = true;
                draft.totalRecords = projectlist.total;
                draft.error = false;
                break;

            case LOAD_PROJECT_ERROR:
                draft.error = error;
                draft.success = false;
                break;

            case LOAD_PHASE_SUCCESS:
                draft.phaselist = phaselist;
                draft.success = true;
                draft.error = false;
                break;
                
            case LOAD_PHASE_ERROR:
                draft.error = error;
                draft.success = false;
                break;  
            
            case LOAD_DROPDOWN_PROJECT_SUCCESS:
                draft.dropdownlist = dropdownlist;
                draft.success = false;
                draft.error = false;
                break;

            case LOAD_DROPDOWN_PROJECT_ERROR:
                draft.error = error;
                draft.success = false;
                break;
                
                default:
                    return state
        }
    })
}
export default Reducer;